/**
 * Pending claim requests — the Plex-style /setup wizard's interactive claim
 * path (approved plan: setup wizard). Mirrors the pins.ts device-link
 * handshake: an unclaimed server creates a request, the owner approves it at
 * app.rago.tv/claim/approve/<code>, and the server polls until redemption
 * hands it a single-use rc- claim token for the existing POST
 * /v1/servers/claim exchange. Validators behind the claim-request slice of
 * contracts/openapi/web-broker.v1.yaml.
 */
import { z } from "zod";
import { publicJwkSchema } from "./auth.js";

export const createClaimRequestSchema = z.object({
  serverId: z.uuid(),
  name: z.string().min(1).max(120),
  version: z.string().max(60).optional(),
  publicKey: publicJwkSchema,
});
export type CreateClaimRequest = z.infer<typeof createClaimRequestSchema>;

export const claimRequestCreatedSchema = z.object({
  id: z.uuid(),
  code: z.string(),
  approveUrl: z.string(),
  expiresAt: z.iso.datetime(),
});
export type ClaimRequestCreated = z.infer<typeof claimRequestCreatedSchema>;

export const claimRequestLookupSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  serverHash: z.string(),
  requestedIp: z.string().nullable(),
  createdAt: z.iso.datetime(),
  alreadyOwnedByOther: z.boolean(),
});
export type ClaimRequestLookup = z.infer<typeof claimRequestLookupSchema>;

export const claimRequestPollSchema = z.discriminatedUnion("status", [
  z.object({ status: z.literal("pending"), expiresAt: z.iso.datetime() }),
  z.object({
    status: z.literal("approved"),
    claimToken: z.string(),
    expiresAt: z.iso.datetime(),
  }),
]);
export type ClaimRequestPoll = z.infer<typeof claimRequestPollSchema>;
